import { ColumnConfig, ColumnDataType } from '@aurora';

export const fleetColumnsConfig: ColumnConfig[] = [
    {
        type           : ColumnDataType.STRING,
        field          : 'company.tenant.name',
        searchableField: '$company.tenant.name$',
        sort           : 'company.tenant.name',
        translation    : 'digitai.CompanyName',
        isUnaccent     : true,
    },
    {
        type           : ColumnDataType.STRING,
        field          : 'aircraftModel.name',
        searchableField: '$aircraftModel.name$',
        sort           : 'aircraftModel.name',
        translation    : 'digitai.AircraftModelName',
        isUnaccent     : true,
    },
    {
        type           : ColumnDataType.STRING,
        field          : 'engineModel.name',
        searchableField: '$engineModel.name$',
        sort           : 'engineModel.name',
        translation    : 'digitai.EngineModelName',
        isUnaccent     : true,
    },
    {
        type       : ColumnDataType.BOOLEAN,
        field      : 'hasOpenIssues',
        sort       : 'hasOpenIssues',
        translation: 'digitai.HasOpenIssues',
    },
    {
        type       : ColumnDataType.BOOLEAN,
        field      : 'hasAiPredictions',
        sort       : 'hasAiPredictions',
        translation: 'digitai.HasAiPredictions',
    },
    {
        type       : ColumnDataType.BOOLEAN,
        field      : 'hasSchedule',
        sort       : 'hasSchedule',
        translation: 'digitai.HasSchedule',
    },
];

export const fleetOperatorColumnsConfig: ColumnConfig[] = [
    {
        type           : ColumnDataType.STRING,
        field          : 'aircraftModel.name',
        searchableField: '$aircraftModel.name$',
        sort           : 'aircraftModel.name',
        translation    : 'digitai.AircraftModelName',
        isUnaccent     : true,
    },
    {
        type           : ColumnDataType.STRING,
        field          : 'engineModel.name',
        searchableField: '$engineModel.name$',
        sort           : 'engineModel.name',
        translation    : 'digitai.EngineModelName',
        isUnaccent     : true,
    },
];

